import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from '../hooks/useTranslation';

const LanguageSwitcher: React.FC = () => {
  const { changeLanguage, currentLanguage } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'uk', name: 'Українська', flag: '🇺🇦' },
  ];

  const menu = (
    <Menu>
      {languages.map((lang) => (
        <Menu.Item 
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          disabled={currentLanguage === lang.code}
        >
          {lang.flag} {lang.name}
        </Menu.Item>
      ))}
    </Menu>
  );

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  return (
    <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
      <Button type="text" icon={<GlobalOutlined />}>
        {currentLang.flag}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
